import {service as AuthService} from "./Core/AuthService";

import {config} from "../Config";

class StreamBankAuthService {
    Logout() {
        return AuthService.Logout().then(x => {
            const iframe = document.createElement('iframe');
            iframe.src = config.getLibraryUrl() + '/logout?iframe=true'; 
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        })
    }
}

export const service = new StreamBankAuthService();

